/**
 * True when local development should authenticate against the sky Cognito user
 * pool (the `sky*` fields of GetIdpConfig) instead of the default pool. This is
 * a local-debugging convenience ONLY: it requires the Vite dev server
 * (import.meta.env.DEV), and production builds bake DEV to false, so no env var
 * or runtime state can ever point a production build at the sky pool — do not
 * weaken this gate to a runtime flag. `npm run start:sky` sets
 * VITE_USE_SKY_IDP=true to opt in.
 */
export const isSkyIdpForced = (env: ImportMetaEnv = import.meta.env): boolean =>
    Boolean(env.DEV) && env.VITE_USE_SKY_IDP === "true";
